<template>
  <div>

    <h2>{{server.name}}</h2>

  </div>
</template>

<script setup>
import {useServersStore} from '@/store/servers'
import {computed, defineProps} from "vue";
const props  = defineProps({
  id: String,
})

// server detail
const serversStore = useServersStore()
const server = computed(() => serversStore.item)
serversStore.getById(props.id)

</script>
